import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EventUtilService} from "../../../../service/utils/event-util.service";
import {EventResponse} from "../../../model/response/event/event-response.model";
import {ImagePreviewService} from "../../../../service/image-preview.service";

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    standalone: false
})
export class ImageComponent implements OnInit, OnChanges {

  @Input('event') event: EventResponse;

  imageLoadFailed = false;

  constructor(
    private eventUtilService: EventUtilService,
    private imagePreviewService : ImagePreviewService,
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['event']) {
      this.imageLoadFailed = false;
    }
  }

  onImageError(): void {
    this.imageLoadFailed = true;
  }

  onContainerClick(): void {
    if (!this.imageLoadFailed) {
      this.displayPreviewImage();
    }
  }

  displayEventImage(): string {
    return this.eventUtilService.displayEventImage(this.event);
  }

  displayPreviewImage() {
    const visibleImage = this.event.blurredImagePath || this.event.originalImagePath
    this.imagePreviewService.openPreview(this.event.explicitImage ? visibleImage : this.displayEventImage())
  }
}
